import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  
  const ho005 = {
    label: "Branch Holiday Schedule",
    pageLabel: "Branch Holiday Schedule",
    starting: true,
    url: "ho005",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            tab: "filterop",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Holiday Type",
            name: "",
            description: "Enter Holiday Type"
          },
          {
            inputType: "select",
            
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "All",
                value: "All"
              },
              {
                label: "Special Holiday",
                value: "SpecialHoliday"
              },
              {
                label: "Weekly Off",
                value: "WeeklyOff"
              },
              {
                label: "Special Reason For Branch Holiday",
                value: "SpecialReasonForBranchHoliday"
              },
              {
                label: "Alternate Week Off",
                value: "AlternateWeekOff"
              }
             ],
            placeHolder: "Holiday Type",
            name: "HolidayType",
            description: "Enter Holiday Type"
          },      
        {
            inputType: "handsonTable",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            // headers:["Car", "Model", "Number", "Date"],
            // data:[],
            label: "",
            name: "branchholidayscheduleHOT",
            description: "none",
            tableOptions: {
              // validations, basic calculations, colors, date pickers, context menu etc.
              HOTheaders: [
                "Branch",
                "Day Of The Week",
                "No",
                "Holiday Until"
              ],
              columns: [
                {},
                { },
                { },
                {}
             
              ],
              rowHeaders: false,
              // contextMenu: true,
              minSpareRows: 4,
              stretchH: "last",
              // columnSorting: true,
              autoWrapRow: true,
              maxRows: 100,
            
            }
          },
    ]
}

export default ho005;